// Static UI copy, keyed `{ en, tr }`. Consumed via `t('key')` from
// `useLanguage()`. Dynamic/content-heavy copy (app data, legal docs) lives
// alongside its data instead, also as `{ en, tr }` fields, read via `L()`.
export const STRINGS = {
  navHome: { en: 'Home', tr: 'Ana Sayfa' },
  navApps: { en: 'Apps', tr: 'Uygulamalar' },
  navStudio: { en: 'Studio', tr: 'Stüdyo' },
  navContact: { en: 'Contact', tr: 'İletişim' },
  navAppStore: { en: 'App Store', tr: 'App Store' },

  footerApps: { en: 'Apps', tr: 'Uygulamalar' },
  footerPrivacy: { en: 'Privacy Policy', tr: 'Gizlilik Politikası' },
  footerTerms: { en: 'Terms of Use', tr: 'Kullanım Şartları' },
  footerContact: { en: 'Contact', tr: 'İletişim' },
  techStackTitle: { en: 'Technologies we use', tr: 'Kullandığımız teknolojiler' },

  storeDownloadOn: { en: 'Download on the', tr: 'İndirin' },
  storeAppStore: { en: 'App Store', tr: 'App Store' },
  storeGetItOn: { en: 'Get it on', tr: 'Hemen edinin' },
  storeGooglePlay: { en: 'Google Play', tr: 'Google Play' },
  storeComingSoon: { en: 'Coming soon on', tr: 'Çok yakında' },

  notFoundLead: { en: "We couldn't find that page.", tr: 'Bu sayfayı bulamadık.' },
  notFoundBackHome: { en: 'Back home', tr: 'Ana sayfaya dön' },

  backToApps: { en: 'Apps', tr: 'Uygulamalar' },
  backToHome: { en: 'Home', tr: 'Ana Sayfa' },
  aboutTitle: { en: 'About', tr: 'Hakkında' },
  legalSupportTitle: { en: 'Legal & Support', tr: 'Yasal & Destek' },
  privacyPolicy: { en: 'Privacy Policy', tr: 'Gizlilik Politikası' },
  termsOfUse: { en: 'Terms of Use', tr: 'Kullanım Şartları' },
  instagram: { en: 'Instagram', tr: 'Instagram' },
  support: { en: 'Support', tr: 'Destek' },

  legalLastUpdated: { en: 'Last updated:', tr: 'Son güncelleme:' },

  heroTitle: {
    en: 'From idea to the App Store, end-to-end product development.',
    tr: 'Fikirden App Store’a, uçtan uca ürün geliştirme.',
  },
  heroLead: {
    en: 'OnyxUp is an independent studio bringing product strategy, interface design, and native iOS engineering under one roof. We design, build, ship, and grow our own products.',
    tr: 'OnyxUp; ürün stratejisini, arayüz tasarımını ve yerel iOS mühendisliğini bir araya getiren bağımsız bir stüdyodur. Kendi ürünlerimizi tasarlar, geliştirir, yayınlar ve büyütürüz.',
  },
  heroOurApps: { en: 'Our Apps', tr: 'Uygulamalarımız' },
  heroGetInTouch: { en: 'Get in touch', tr: 'Bize ulaşın' },

  appsTitle: { en: 'Apps.', tr: 'Uygulamalar.' },
  studioTitle: { en: 'Studio.', tr: 'Stüdyo.' },

  studioStatementBig: {
    en: "We're a small studio, and that's by design.",
    tr: 'Küçük bir stüdyoyuz ve bu bilinçli bir seçim.',
  },
  studioStatementSoft: {
    en: 'We build a handful of apps and keep improving each one long after launch.',
    tr: 'Az sayıda uygulama geliştiriyor ve her birini çıkıştan uzun süre sonra da iyileştirmeye devam ediyoruz.',
  },
  studioSideP: {
    en: 'We design, build, and ship every step ourselves — from the first idea to the App Store.',
    tr: 'İlk fikirden App Store’a kadar her adımı kendimiz tasarlar, geliştirir ve yayınlarız.',
  },
  studioFounderTitle: { en: 'Product & Mobile developer', tr: 'Ürün & Mobil geliştirici' },

  principleSafetyTitle: { en: 'Safety First', tr: 'Önce Güvenlik' },
  principleSafetyBody: {
    en: 'Privacy and security are designed in from the start. We process only the data we need, and we never track you across other apps.',
    tr: 'Gizlilik ve güvenlik en baştan tasarıma dahil edilir. Yalnızca gerekli verileri işleriz ve sizi diğer uygulamalarda takip etmeyiz.',
  },
  principleProductTitle: { en: 'Product Development', tr: 'Ürün Geliştirme' },
  principleProductBody: {
    en: 'Idea, design, engineering, and release all happen under one roof. We keep moving the product forward with every release based on real feedback.',
    tr: 'Fikir, tasarım, mühendislik ve yayınlama tek çatı altında gerçekleşir. Her sürümde gerçek geri bildirimlere dayanarak ürünü ileriye taşırız.',
  },
  principleMaintainableTitle: { en: 'Maintainable', tr: 'Sürdürülebilir' },
  principleMaintainableBody: {
    en: 'Clean architecture, native Swift, and testable code. Our apps are built to stay healthy and current for years to come.',
    tr: 'Temiz mimari, yerel Swift ve test edilebilir kod. Uygulamalarımız yıllarca sağlıklı ve güncel kalacak şekilde inşa edilir.',
  },

  contactTitleLine1: { en: 'Got an idea?', tr: 'Bir fikriniz mi var?' },
  contactTitleLine2: { en: "Let's talk.", tr: 'Konuşalım.' },
  contactLead: {
    en: 'Reach out for feedback, collaboration, or support. We usually reply within 24 hours.',
    tr: 'Geri bildirim, iş birliği veya destek için bize ulaşın. Genellikle 24 saat içinde yanıt veririz.',
  },
  contactEmailLabel: { en: 'Email', tr: 'E-posta' },
  contactEmailPlaceholder: { en: 'your@email.com', tr: 'adiniz@eposta.com' },
  contactMessageLabel: { en: 'Message', tr: 'Mesaj' },
  contactMessagePlaceholder: { en: 'How can we help?', tr: 'Size nasıl yardımcı olabiliriz?' },
  contactSend: { en: 'Send', tr: 'Gönder' },
  contactSending: { en: 'Sending…', tr: 'Gönderiliyor…' },
  contactFillAllFields: { en: 'Please fill in all fields', tr: 'Lütfen tüm alanları doldurun' },
  contactInvalidEmail: { en: 'Please enter a valid email address', tr: 'Lütfen geçerli bir e-posta adresi girin' },
  contactSendingToast: { en: 'Sending message...', tr: 'Mesaj gönderiliyor...' },
  contactSentToast: { en: 'Message sent successfully!', tr: 'Mesajınız başarıyla gönderildi!' },
  contactFailedToast: { en: 'Failed to send message. Please try again later.', tr: 'Mesaj gönderilemedi. Lütfen daha sonra tekrar deneyin.' },
};
